import EmploiSelect from '@/generated/controls/emploi/EmploiSelect.vue';
import Emploi from '@/generated/classes/Emploi';
import { GenCustom, RessourceGenCustom } from '@/generated/ressources/generatedRessources';
import Contrat from '@/generated/classes/Contrat';
import { defineComponent } from "vue";

export default defineComponent({
  extends: EmploiSelect,
  name: 'EmploiSelectExtend',
  components: {},
  data() {
    return {
      ignoreLicence: false,
    };
  },
  computed: {    
    items(): Emploi[] {
      if (this.reset != this.toggleReset || (this.contrat && this.contrat.ignoreLicence != this.ignoreLicence)) {
        this.reset = this.toggleReset;
        this.ignoreLicence = this.contrat ? this.contrat.ignoreLicence : false;
        let contrat = this.contrat;
        if (!contrat) {
          contrat = new Contrat()
        }
        Emploi.IdccEmploi(contrat)
          .then((res) => {
            this.listEmploi = res;
            this.listUpdated = true;
          }).catch(() => {
            //Catch empty list
          });
      }
      return this.listEmploi;
    },
  },
  methods: {
    getDisplay(emploi: Emploi): string | null {
      let value = emploi.nom;
      if (value.endsWith(' CADRE') && emploi.cadre) {
        value = value.substring(0, value.length - 6);
      }
      let ressourceLabel = '';
      if (emploi.artiste) {
        ressourceLabel = RessourceGenCustom(GenCustom.CONTRAT_SALARIE_ARTISTE).label;
      }
      else {
        ressourceLabel = RessourceGenCustom(GenCustom.CONTRAT_SALARIE_TECHNICIEN).label;
      }
      value += ` (${ressourceLabel}`;
      if (emploi.cadre != null) {
        if (emploi.cadre) {
          ressourceLabel = RessourceGenCustom(GenCustom.CONTRAT_SALARIE_CADRE).label;
        }
        else {
          ressourceLabel = RessourceGenCustom(GenCustom.CONTRAT_SALARIE_NON_CADRE).label;
        }
        value += ` ${ressourceLabel})`;
      }
      else {
        value += ")";
      }
      return value
    },
  },
});
